import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import MuiCheckIcon from '@mui/icons-material/Check';
import rose from '../Palettes/rose';

interface ChecklistItemDefinition {
  key: string;
  label: ReactNode;
}

interface ChecklistProperties {
  items: ChecklistItemDefinition[];
  className?: string;
}

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 1.5rem 0 0;
`;

const Item = styled.li`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
`;

const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${rose[100]};
  color: ${rose[600]};

  svg {
    font-size: 0.875rem;
  }
`;

const Checklist = ({ items, className }: ChecklistProperties) => (
  <List className={className}>
    {items.map(({ key, label }) => (
      <Item key={key}>
        <IconWrapper>
          <MuiCheckIcon />
        </IconWrapper>
        <span>{label}</span>
      </Item>
    ))}
  </List>
);

export default Checklist;
